module.exports = __webpack_public_path__ + "img/1.46e6fea7.jpg";